import React from 'react'

function SelectedBasket() {
  return (
    <div>
        <h1>Selected Basket</h1>
    </div>
  )
}

export default SelectedBasket
